import { render, staticRenderFns } from "./CommitteeForm.vue?vue&type=template&id=b0cd3458&scoped=true&"
import script from "./CommitteeForm.vue?vue&type=script&lang=js&"
export * from "./CommitteeForm.vue?vue&type=script&lang=js&"
import style0 from "./CommitteeForm.vue?vue&type=style&index=0&id=b0cd3458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cd3458",
  null
  
)

export default component.exports